import { List } from 'antd'
import {
    PlayCircleOutlined,
    QuestionCircleOutlined,
    TeamOutlined,
    ToolOutlined,
} from '@ant-design/icons'

import Box from '~/core/Box'
import Image from '~/core/Image'
import Link from '~/core/Link'
import Text from '~/core/Text'
import icons from '~/apps/consumer/icons'
import getColor from '~/lib/getColor'

import { CARD_LIST } from './constants'

const PLACEMENT = 'on-board-drawer-body'

type ListItemType = {
    title: string
    description: string
    icon: string
    antdIcon: boolean
    iconDescription: string
    hasSubMenu?: boolean
    link: string
}

export default function DrawerBody({ onClick }: { onClick: () => void }) {
    const handleOnClick = (evt: Event, link?: string, hasSubMenu?: boolean) => {
        evt.preventDefault()
        if (!link && hasSubMenu) {
            onClick()
        } else if (link) {
            window.open(link, '_blank', 'noopener')
        }
    }

    const getIcon = (iconName: string, isAntd: boolean) => {
        if (!isAntd) {
            return (
                <Image
                    src={icons[iconName as keyof typeof icons] as string}
                    width="24px"
                />
            )
        }
        let icon

        switch (iconName) {
            case 'play-circle':
                icon = <PlayCircleOutlined style={{ fontSize: '20px' }} />
                break
            case 'question-circle':
                icon = <QuestionCircleOutlined style={{ fontSize: '20px' }} />
                break
            case 'team':
                icon = <TeamOutlined style={{ fontSize: '20px' }} />
                break
            case 'tool':
            default:
                icon = <ToolOutlined style={{ fontSize: '20px' }} />
                break
        }

        return icon
    }

    const renderCard = ({
        title,
        description,
        icon,
        antdIcon,
        iconDescription,
        hasSubMenu,
        link,
    }: ListItemType) => {
        const name = title.split(' ').join('-')

        return (
            <List.Item>
                <Link
                    data-test-target={`list-item-${name}-${PLACEMENT}`}
                    name={`list-item-${name}`}
                    onClick={(evt: Event) =>
                        handleOnClick(evt, link, hasSubMenu)
                    }
                    placement={PLACEMENT}
                    style={{
                        alignItems: 'center',
                        color: getColor('blackAlpha65'),
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '32px 0px',
                    }}
                >
                    <Box direction="col" marginRight="32px">
                        <Link
                            data-test-target={`link-${name}-${PLACEMENT}`}
                            name={name}
                            onClick={(evt: Event) => evt.preventDefault}
                            placement={PLACEMENT}
                            style={{ lineHeight: '22px', fontWeight: 400 }}
                        >
                            {title}
                        </Link>
                        <Text fontSize="11px">{description}</Text>
                    </Box>
                    <Box direction="col" alignItems="center" minWidth="64px">
                        {getIcon(icon, antdIcon)}
                        <Text fontSize="11px" style={{ marginTop: '8px' }}>
                            {iconDescription}
                        </Text>
                    </Box>
                </Link>
            </List.Item>
        )
    }

    return (
        <List
            dataSource={CARD_LIST}
            itemLayout="horizontal"
            renderItem={renderCard}
            style={{ margin: '0px 32px' }}
        />
    )
}
